export const injectProxies = (proxiesUrl = 'https://dev.api1.worldfavor.com/api/proxies') => {
    const scriptElement = document.createElement('script')
    scriptElement.type = 'text/javascript'
    scriptElement.src = `${proxiesUrl}?_=${Date.now()}`
    document.head.appendChild(scriptElement)
}
